import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "package-modal" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "form-section" }
const _hoisted_5 = { class: "builder-grid" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "upload-copy" }
const _hoisted_8 = { class: "upload-actions" }
const _hoisted_9 = { class: "form-section" }
const _hoisted_10 = { class: "two-column" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "field price-field" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { class: "configuration-grid" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "form-section" }
const _hoisted_17 = { class: "two-column" }
const _hoisted_18 = { class: "upload-copy" }
const _hoisted_19 = { class: "upload-actions" }
const _hoisted_20 = { class: "upload-copy" }
const _hoisted_21 = { class: "upload-actions" }
const _hoisted_22 = { class: "assignment-section" }
const _hoisted_23 = { class: "field stage-field" }
const _hoisted_24 = ["aria-expanded"]
const _hoisted_25 = ["aria-selected", "onClick"]
const _hoisted_26 = { class: "assignment-summary" }
const _hoisted_27 = { class: "lot-options" }
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 0,
  class: "assigned-across"
}
const _hoisted_30 = { class: "modal-footer" }
const _hoisted_31 = {
  key: 0,
  class: "validation-message"
}
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    ($props.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "package-modal-backdrop",
          onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h2", null, _toDisplayString($props.packageData ? "Edit Package" : "Create Package"), 1),
              _createElementVNode("button", {
                class: "icon-button",
                type: "button",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, [
                _createVNode($setup["X"], { size: 18 })
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("section", _hoisted_4, [
                _cache[24] || (_cache[24] = _createElementVNode("h3", null, "Builder Details", -1)),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, [
                    _cache[20] || (_cache[20] = _createElementVNode("span", null, "Builder *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.builderName) = $event)),
                      type: "text",
                      placeholder: "e.g. Metricon"
                    }, null, 512), [
                      [
                        _vModelText,
                        $setup.form.builderName,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", {
                    class: _normalizeClass(["upload-field", { 'has-file': $setup.logoDisplayName }])
                  }, [
                    _createVNode($setup["ImageIcon"], { size: 18 }),
                    _createElementVNode("div", _hoisted_7, [
                      ($setup.logoDisplayName)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("strong", null, _toDisplayString($setup.logoDisplayName), 1),
                            _cache[21] || (_cache[21] = _createElementVNode("small", null, "Click to replace", -1))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Upload logo", -1)),
                            _cache[23] || (_cache[23] = _createElementVNode("small", null, "PNG or SVG", -1))
                          ], 64))
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      ($setup.logoDisplayName)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "remove-upload",
                            type: "button",
                            "aria-label": "Remove logo",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.removeFile('logo')), ["prevent","stop"]))
                          }, [
                            _createVNode($setup["X"], { size: 13 })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode($setup["Upload"], { size: 18 })
                    ]),
                    _createElementVNode("input", {
                      ref: "logoInput",
                      type: "file",
                      accept: "image/png,image/jpeg,image/svg+xml,image/webp",
                      onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.selectFile('logo', $event)))
                    }, null, 544)
                  ], 2)
                ])
              ]),
              _createElementVNode("section", _hoisted_9, [
                _cache[29] || (_cache[29] = _createElementVNode("h3", null, "Package Details", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, [
                    _cache[25] || (_cache[25] = _createElementVNode("span", null, "Package / Design Name *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.designName) = $event)),
                      type: "text",
                      placeholder: "e.g. Riviera 35"
                    }, null, 512), [
                      [
                        _vModelText,
                        $setup.form.designName,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_12, [
                    _cache[27] || (_cache[27] = _createElementVNode("span", null, "Package Price *", -1)),
                    _createElementVNode("div", null, [
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "currency" }, "$", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.packagePrice) = $event)),
                        type: "number",
                        min: "0",
                        placeholder: "e.g. 250000"
                      }, null, 512), [
                        [
                          _vModelText,
                          $setup.form.packagePrice,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_13, [
                    _cache[28] || (_cache[28] = _createElementVNode("span", null, "Facade Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.facadeName) = $event)),
                      type: "text",
                      placeholder: "e.g. Outback"
                    }, null, 512), [
                      [
                        _vModelText,
                        $setup.form.facadeName,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "configuration-label" }, "Configuration *", -1)),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.configurationFields, (field) => {
                    return _createElementVNode("label", {
                      class: "field",
                      key: field.key
                    }, [
                      _createElementVNode("span", null, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(field.icon), { size: 13 })),
                        _createTextVNode(" " + _toDisplayString(field.label), 1)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => (($setup.form[field.key]) = $event),
                        type: "number",
                        min: "0"
                      }, null, 8, _hoisted_15), [
                        [
                          _vModelText,
                          $setup.form[field.key],
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])
                  }), 64))
                ])
              ]),
              _createElementVNode("section", _hoisted_16, [
                _cache[37] || (_cache[37] = _createElementVNode("h3", null, "Media", -1)),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["upload-field", { 'has-file': $setup.heroDisplayName }])
                  }, [
                    _createVNode($setup["ImageIcon"], { size: 18 }),
                    _createElementVNode("div", _hoisted_18, [
                      ($setup.heroDisplayName)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("strong", null, _toDisplayString($setup.heroDisplayName), 1),
                            _cache[31] || (_cache[31] = _createElementVNode("small", null, "Click to replace", -1))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[32] || (_cache[32] = _createElementVNode("strong", null, "Upload hero image", -1)),
                            _cache[33] || (_cache[33] = _createElementVNode("small", null, "PNG or JPG, up to 10 MB", -1))
                          ], 64))
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      ($setup.heroDisplayName)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "remove-upload",
                            type: "button",
                            "aria-label": "Remove hero image",
                            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => ($setup.removeFile('hero')), ["prevent","stop"]))
                          }, [
                            _createVNode($setup["X"], { size: 13 })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode($setup["Upload"], { size: 18 })
                    ]),
                    _createElementVNode("input", {
                      ref: "heroInput",
                      type: "file",
                      accept: "image/png,image/jpeg,image/webp",
                      onChange: _cache[8] || (_cache[8] = ($event: any) => ($setup.selectFile('hero', $event)))
                    }, null, 544)
                  ], 2),
                  _createElementVNode("label", {
                    class: _normalizeClass(["upload-field", { 'has-file': $setup.brochureDisplayName }])
                  }, [
                    _createVNode($setup["FileText"], { size: 18 }),
                    _createElementVNode("div", _hoisted_20, [
                      ($setup.brochureDisplayName)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("strong", null, _toDisplayString($setup.brochureDisplayName), 1),
                            _cache[34] || (_cache[34] = _createElementVNode("small", null, "Click to replace", -1))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[35] || (_cache[35] = _createElementVNode("strong", null, "Upload brochure", -1)),
                            _cache[36] || (_cache[36] = _createElementVNode("small", null, "PDF, up to 10 MB", -1))
                          ], 64))
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      ($setup.brochureDisplayName)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "remove-upload",
                            type: "button",
                            "aria-label": "Remove brochure",
                            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => ($setup.removeFile('brochure')), ["prevent","stop"]))
                          }, [
                            _createVNode($setup["X"], { size: 13 })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode($setup["Upload"], { size: 18 })
                    ]),
                    _createElementVNode("input", {
                      ref: "brochureInput",
                      type: "file",
                      accept: "application/pdf",
                      onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.selectFile('brochure', $event)))
                    }, null, 544)
                  ], 2)
                ])
              ]),
              _createElementVNode("section", _hoisted_22, [
                _cache[40] || (_cache[40] = _createElementVNode("h3", null, "Assign to Lots", -1)),
                _cache[41] || (_cache[41] = _createElementVNode("p", null, "Choose a stage, then select the lots this package is available on.", -1)),
                _createElementVNode("div", _hoisted_23, [
                  _cache[38] || (_cache[38] = _createElementVNode("span", { id: "stage-select-label" }, "Select stage", -1)),
                  _createElementVNode("div", {
                    class: "stage-select",
                    onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("button", {
                      class: "stage-select-trigger",
                      ref: "stageSelectTrigger",
                      type: "button",
                      "aria-labelledby": "stage-select-label",
                      "aria-haspopup": "listbox",
                      "aria-expanded": $setup.stageSelectOpen,
                      onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.stageSelectOpen = !$setup.stageSelectOpen)),
                      onKeydown: [
                        _cache[12] || (_cache[12] = _withKeys(_withModifiers(($event: any) => ($setup.stageSelectOpen = true), ["prevent"]), ["down"])),
                        _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => ($setup.stageSelectOpen = false), ["stop"]), ["esc"]))
                      ]
                    }, [
                      _createElementVNode("span", null, _toDisplayString($setup.selectedStageLabel), 1),
                      _createVNode($setup["ChevronDown"], {
                        size: 16,
                        class: _normalizeClass({ open: $setup.stageSelectOpen })
                      }, null, 8, ["class"])
                    ], 40, _hoisted_24),
                    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                      _createVNode(_Transition, { name: "stage-options" }, {
                        default: _withCtx(() => [
                          ($setup.stageSelectOpen)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "stage-options",
                                role: "listbox",
                                "aria-labelledby": "stage-select-label",
                                style: _normalizeStyle($setup.stageOptionsStyle),
                                onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
                                onKeydown: _cache[15] || (_cache[15] = _withKeys(_withModifiers(($event: any) => ($setup.stageSelectOpen = false), ["stop"]), ["esc"]))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.stages, (stage) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    class: _normalizeClass(["stage-option", { selected: $setup.selectedStageId === stage._id }]),
                                    key: stage._id,
                                    type: "button",
                                    role: "option",
                                    "aria-selected": $setup.selectedStageId === stage._id,
                                    onClick: ($event: any) => ($setup.selectStage(stage._id))
                                  }, [
                                    _createVNode($setup["Check"], {
                                      size: 15,
                                      class: _normalizeClass({ visible: $setup.selectedStageId === stage._id })
                                    }, null, 8, ["class"]),
                                    _createElementVNode("span", null, "Stage " + _toDisplayString(stage.title), 1)
                                  ], 10, _hoisted_25))
                                }), 128))
                              ], 36))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", null, _toDisplayString($setup.currentStageLots.length) + " lots · " + _toDisplayString($setup.selectedCurrentStageCount) + " selected", 1),
                  _createElementVNode("button", {
                    class: "link-button",
                    type: "button",
                    onClick: $setup.toggleSelectAll
                  }, _toDisplayString($setup.allCurrentStageSelected ? "Clear all" : "Select all"), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentStageLots, (lot) => {
                    return (_openBlock(), _createElementBlock("label", {
                      class: "lot-option",
                      key: lot._id
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: lot._id,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.form.lotIds) = $event))
                      }, null, 8, _hoisted_28), [
                        [_vModelCheckbox, $setup.form.lotIds]
                      ]),
                      _createElementVNode("span", null, "Lot " + _toDisplayString(lot.title), 1)
                    ]))
                  }), 128))
                ]),
                ($setup.assignedStageGroups.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _cache[39] || (_cache[39] = _createElementVNode("strong", null, "Assigned across stages", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.assignedStageGroups, (group) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "assigned-stage",
                          key: group.stageId
                        }, [
                          _createElementVNode("span", null, "Stage " + _toDisplayString(group.stageTitle) + ":", 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.lots, (lot) => {
                            return (_openBlock(), _createElementBlock("em", {
                              key: lot._id
                            }, "Lot " + _toDisplayString(lot.title), 1))
                          }), 128))
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              ($setup.validationMessage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString($setup.validationMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "cancel-button",
                type: "button",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('close')))
              }, "Cancel"),
              _createElementVNode("button", {
                class: "save-button",
                type: "button",
                disabled: $props.saving,
                onClick: $setup.submit
              }, _toDisplayString($props.saving ? "Saving…" : $props.packageData ? "Update Package" : "Create Package"), 9, _hoisted_32)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}